const withdrawV2Router = [
  {
    path: "/withdraw-v2",
    name: "withdraw-v2-alert",
    component: () => import("../views/withdraw-v2/WithdrawAlertView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/withdraw-v2/notice",
    name: "withdraw-v2-notice",
    component: () => import("../views/withdraw-v2/WithdrawNoticeView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/withdraw-v2/services",
    name: "withdraw-v2-services",
    component: () => import("../views/withdraw-v2/WithdrawServicesView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/withdraw-v2/unable",
    name: "withdraw-v2-unable",
    component: () => import("../views/withdraw-v2/WithdrawUnableView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/withdraw-v2/expectation",
    name: "withdraw-v2-expectation",
    component: () => import("../views/withdraw-v2/WithdrawExpectationView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/withdraw-v2/reason",
    name: "withdraw-v2-reason",
    component: () => import("../views/withdraw-v2/WithdrawReasonView.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/withdraw-v2/complete",
    name: "withdraw-v2-complete",
    component: () => import("../views/withdraw-v2/WithdrawCompleteView.vue"),
  },
  {
    path: "/withdraw-v2/pending",
    name: "withdraw-v2-pending",
    component: () => import("../views/withdraw-v2/WithdrawPendingView.vue"),
  },
];

export default withdrawV2Router;
